import React from 'react';
import styled from 'astroturf/react';

const Dock = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 2147483000;
`;

const Bar = styled.div`
  align-items: center;
  background: #000;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  gap: 10px;
  line-height: 1.4;
  padding: 8px 12px;
`;

const Title = styled.span`
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const Detail = styled.span`
  color: #bbb;
`;

const LoggedOutBucketingBar: React.FC = () => (
  <Dock>
    <Bar>
      <Title>Logged-out test override</Title>
      <Detail>Logged-out test bucketing will go here</Detail>
    </Bar>
  </Dock>
);

export default LoggedOutBucketingBar;
